angular.
module("dx.webapp.import", [
	"dx.webapp.droparea",
	"dx.webapp.question",
	"dx.webapp.navigation",

	"dx.ui.components.dialog",
	"dx.ui.components.localize",
]);
